export default class Utils {


static getURL(){
    //   return new URL('server/srv-res.php', 'http://localhost:3000/augustin/reservation/');            

      return new URL('server/srv-res.php', 'https://reservation.augustinbrno.cz/');            
      }
  }
